module.exports = __webpack_public_path__ + "static/media/orinocco84.d63776fe.jpg";